'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactI18next = require('react-i18next');

var _FormInput = require('../FormInput');

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_SELECT_VALUE = 10;

var LineItemQuantity = (_dec = (0, _reactI18next.translate)(), _dec2 = (0, _reactCssModules2.default)(_style2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(LineItemQuantity, _React$Component);

  function LineItemQuantity(props) {
    (0, _classCallCheck3.default)(this, LineItemQuantity);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LineItemQuantity.__proto__ || (0, _getPrototypeOf2.default)(LineItemQuantity)).call(this, props));

    _this.handleLocalChange = function (e) {
      var newQuantity = parseInt(e.target.value, 10);
      _this.setState({ currentQuantity: newQuantity });
    };

    _this.handleButtonClick = function (e) {
      e.preventDefault();
      var changeEvent = {
        target: {
          name: 'order[line_items_attributes][' + _this.props.index + '][quantity]',
          value: _this.state.currentQuantity
        }
      };

      _this.setState({
        pendingQuantity: _this.state.currentQuantity
      }, function () {
        _this.props.onChange(changeEvent);
      });
    };

    _this.state = {
      currentQuantity: props.quantity,
      pendingQuantity: null
    };
    return _this;
  }

  (0, _createClass3.default)(LineItemQuantity, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.state.pendingQuantity !== null) {
        if (this.props.errorMessage) {
          // eslint-disable-next-line react/no-did-update-set-state
          this.setState({
            currentQuantity: this.props.quantity,
            pendingQuantity: null
          });
        } else if (this.props.quantity !== prevProps.quantity) {
          // eslint-disable-next-line react/no-did-update-set-state
          this.setState({
            currentQuantity: this.props.quantity,
            pendingQuantity: null
          });
        }
      }
    }
  }, {
    key: 'inputdefaults',
    value: function inputdefaults() {
      return {
        id: 'order_line_item_attribute_' + this.props.index + '_quantity',
        name: 'order[line_items_attributes][' + this.props.index + '][quantity]',
        defaultValue: this.props.quantity
      };
    }
  }, {
    key: 'renderQuantity',
    value: function renderQuantity() {
      var _context;

      if (this.renderAsInput()) {
        var t = this.props.t;

        return _react2.default.createElement(
          'div',
          { styleName: 'o-quantity', className: 'clearfix' },
          _react2.default.createElement(
            'div',
            { styleName: 'o-quantity--input' },
            _react2.default.createElement(_FormInput.Input, (0, _extends3.default)({}, this.inputdefaults(), {
              value: this.state.currentQuantity,
              onChange: this.handleLocalChange,
              type: 'number',
              min: 0,
              required: true
            }))
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'o-quantity--button' },
            _react2.default.createElement(
              _FormInput.Button,
              {
                onClick: this.handleButtonClick,
                title: t('spree.update'),
                type: 'update',
                weight: 'secondary-auto'
              },
              _react2.default.createElement(_Icon2.default, { type: 'update' })
            )
          )
        );
      }

      var options = Array(MAX_SELECT_VALUE + 1).fill().map(function (_key, int) {
        return [int, int];
      });
      options.push(['+more', 'More']);

      return _react2.default.createElement(_FormInput.Select, {
        id: 'order_line_item_attribute_' + this.props.index + '_quantity',
        name: 'order[line_items_attributes][' + this.props.index + '][quantity]',
        value: this.props.quantity,
        onChange: (_context = this.props).onChange.bind(_context),
        options: options
      });
    }
  }, {
    key: 'renderAsInput',
    value: function renderAsInput() {
      return this.props.showInput || this.props.quantity > MAX_SELECT_VALUE;
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'label',
          {
            styleName: 'lineItemQuantity__label',
            className: 'hidden-md-up',
            htmlFor: 'order_line_item_attribute_' + this.props.index + '_quantity'
          },
          t('spree.quantity')
        ),
        _react2.default.createElement('br', { className: 'hidden-md-up' }),
        this.renderQuantity()
      );
    }
  }]);
  return LineItemQuantity;
}(_react2.default.Component), _class2.propTypes = {
  id: _react.PropTypes.number.isRequired,
  quantity: _react.PropTypes.number.isRequired,
  onChange: _react.PropTypes.func.isRequired,
  showInput: _react.PropTypes.bool,
  index: _react.PropTypes.number.isRequired,
  errorMessage: _react.PropTypes.bool.isRequired
}, _class2.defaultProps = {
  showInput: false
}, _temp)) || _class) || _class);
exports.default = LineItemQuantity;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/LineItemQuantity/index.js
// module id = 2476
// module chunks = 0